import React from "react";
import { Link } from "react-router-dom";

const PricingCard = ({ moduleKey, moduleLabel, tier }) => {
  const ctaTo = `/contact?module=${encodeURIComponent(moduleKey)}&tier=${encodeURIComponent(tier.key)}`;
  return (
    <article
      className={`mk-pricing-card${tier.popular ? " popular" : ""}`}
      data-testid={`pricing-card-${moduleKey}-${tier.key}`}
      data-popular={tier.popular ? "true" : "false"}
    >
      <span className="mk-pricing-module">{moduleLabel}</span>
      <h3>{tier.name}</h3>
      {tier.description && <p>{tier.description}</p>}
      <div className="mk-price">
        <strong>{tier.price}</strong>
        {tier.suffix && <span>{tier.suffix}</span>}
      </div>
      {tier.priceNote && <p style={{ marginTop: "-6px", fontSize: "13px", color: "#68768b" }}>{tier.priceNote}</p>}
      <ul className="mk-pricing-features">
        {tier.features.map((feat) => (
          <li key={feat}>{feat}</li>
        ))}
      </ul>
      <Link to={ctaTo} className={`mk-btn ${tier.popular ? "mk-btn-primary" : "mk-btn-dark"}`}>
        Choisir l'option
      </Link>
    </article>
  );
};

export default PricingCard;
